import { lazy } from "react";
const OtTradeBoardBase = lazy(() => import("app/pages/ot/tradeBoard/BoardBase"));
const OtTradeConfirmBase = lazy(() => import("app/pages/ot/tradeConfirm/list/TradeConfirmBase"));
const OtTradeConfirmBoardDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmBoardDetail"));
const OtTradeConfirmApplyDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmApplyDetail"));
const ContractListBase = lazy(() => import("app/pages/cb/contractList/ContractListBase"));
const MoneyStatusBase = lazy(() => import("app/pages/ot/moneyStatus/MoneyStatusBase"));
const MoneyHistoryBase = lazy(() => import("app/pages/ot/moneyHistory/MoneyHistoryBase"));
const BillListBase = lazy(() => import("app/pages/cb/billList/BillListBase"));
const BillFormBase = lazy(() => import("app/pages/cb/billForm/BillFormBase"));
const BillDetailBase = lazy(() => import("app/pages/cb/billDetail/BillDetailBase"));
const BillFormModify = lazy(() => import("app/pages/cb/billForm/BillFormModify"));

const TradeContractForm = lazy(() => import("app/pages/cb/contractForm/ContractFormBase"));
const TradeContractDetail = lazy(() => import("app/pages/cb/contractDetail/ContractDetailBase"));
const TradeRpdc = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdc"));
const TradeRpdcForm = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcForm"));
const TradeRpdcDetail = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcDetail"))
const MoneyRpdc = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdc"));
const MoneyRpdcForm = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdcForm"));
const MoneyRpdcDetail = lazy(() => import("app/pages/ot/moneyRpdc/MoneyRpdcDetail"));

export const otRouter: any = [
  // 에너지마켓 장외거래
  { path: '/ot/emission/trade', element: <OtTradeBoardBase />, },
  { path: '/ot/rec/trade', element: <OtTradeBoardBase />, },

  // 에너지마켓 장외거래 - confirm
  { path: '/ot/emission/contract', element: <OtTradeConfirmBase /> },
  { path: '/ot/emission/contract/board/detail', element: <OtTradeConfirmBoardDetail /> },
  { path: '/ot/emission/contract/apply/detail', element: <OtTradeConfirmApplyDetail /> },
  { path: '/ot/rec/contract', element: <OtTradeConfirmBase /> },
  { path: '/ot/rec/contract/board/detail', element: <OtTradeConfirmBoardDetail /> },
  { path: '/ot/rec/contract/apply/detail', element: <OtTradeConfirmApplyDetail /> },

  // 에너지마켓 계약관리
  { path: '/ot/contract', element: <ContractListBase /> },
  { path: '/ot/contract/form', element: <TradeContractForm /> },
  { path: '/ot/contract/detail', element: <TradeContractDetail /> },

  // 에너지마켓 유연자원시장 거래 현황
  { path: '/ot/money/hd/status', element: <MoneyStatusBase /> },
  { path: '/ot/money/dc/status', element: <MoneyStatusBase /> },

  // 에너지마켓 유연자원시장 이력관리
  { path: '/ot/money/hd/history', element: <MoneyHistoryBase /> },
  { path: '/ot/money/dc/history', element: <MoneyHistoryBase /> },

  // 에너지마켓 부정거래 신고
  { path: '/ot/trade/rpdcs', element: <TradeRpdc /> },
  { path: '/ot/trade/rpdcs/form', element: <TradeRpdcForm /> },
  { path: '/ot/trade/rpdcs/detail', element: <TradeRpdcDetail /> },

  // 에너지마켓 정산조정 신청
  { path: '/ot/money/rpdcs', element: <MoneyRpdc /> },
  { path: '/ot/money/rpdcs/form', element: <MoneyRpdcForm /> },
  { path: '/ot/money/rpdcs/detail', element: <MoneyRpdcDetail /> },

  // 에너지마켓 정산관리
  { path: '/ot/bill', element: <BillListBase /> },
  { path: '/ot/bill/form', element: <BillFormBase /> },
  { path: '/ot/bill/modify', element: <BillFormModify /> },
  { path: '/ot/bill/detail', element: <BillDetailBase /> },
];